var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"topDiv"},[_c('HomeCarsouel'),_c('HomeContent',{staticStyle:{"margin-top":"100vh"}}),_c('HomeShicha'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }